module.exports = __webpack_public_path__ + "img/slide-35.762ed390.jpeg";